import { render, staticRenderFns } from "./UxLayer.vue?vue&type=template&id=390ccf6e&"
import script from "./UxLayer.vue?vue&type=script&lang=js&"
export * from "./UxLayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/bsjung/work/xtc/trading-chart-js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('390ccf6e')) {
      api.createRecord('390ccf6e', component.options)
    } else {
      api.reload('390ccf6e', component.options)
    }
    module.hot.accept("./UxLayer.vue?vue&type=template&id=390ccf6e&", function () {
      api.rerender('390ccf6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UxLayer.vue"
export default component.exports